// extracted by mini-css-extract-plugin
module.exports = {"card":"timerange_card__1p35A","tag":"timerange_tag__1ahyH","titleFilter":"timerange_titleFilter__2mMxr"};